import React from 'react';
import './Index.scss'
import Config from "../../asstes/js/Config";
import AdComponent from "../../components/AdComponent/AdComponent";
import GiftListComponent from "../../components/GiftListComponent/GiftListComponent";
import FloatNavigation from "../../components/FloatNavigation/FloatNavigation";
import {isInBocApp, showLogin, getTimeString, setStorageCache} from "../../asstes/js/Utils";
import {bocLogin, changeBocString, getRankList} from "../../asstes/js/Rescource";
import {
	clearUserInfo,
	isNotLoggedIn,
	showToast,
	returnBocUserInfo,
	showTipsAlert,
	getUserOrderList,
	historyOfPush,
	showShareModules,
	showZhShareModules,
	getAuthorize,
	showPassWordLogin,
} from "../../asstes/js/IntegratedProcessing";
import {getAllProductList} from "../../asstes/js/Rescource";
import PayComponent from "../../components/PayComponent/PayComponent";
import SelectPayComponent from "../../components/SelectPayComponent/SelectPayComponent";
import OrderComponent from "../../components/OrderComponent/OrderComponent";
import history from "../../router/history";
import ShareOtherComponent from "../../components/ShareOtherComponent/ShareOtherComponent";
import BannerComponent from "../../components/BannerComponent/BannerComponent";

class Index extends React.Component {
	state = {
		imgOne: false,
		imgTwo: false,
		loopHeight: 0,
		selectIdx: -1,
		// cipherText: `{"body":"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","skey":"it+Er9npi4s6IFoZO6PnExYhNYhSNv7+DFxdWJRiFuQQs7Gnx+7FbjZTDbVKTlI/AH+g8HhznbWBFBG9zNojYFvzZKBFvjf1AdhW3IUEamWOGI6bjYdVoAIORapgMkx4/KbAUGg3onY9BXbiJlolREPidoSDKilJl+0SbWmcRzw="}`,
		cipherText: '',
		loginTime: 0, // 中行APP的登录次数
		// payInfo: {"actionNo":"ACT_WUNKGLLC","actionCode":"ACTION_BOC_OPEN_RED","actionName":"中行拆锦盒行为","amount":null,"signinCount":null,"signinCountList":[],"signinCountTotal":null,"actionObjectList":[{"id":79600000011406,"actionRelId":79500000003463,"keyCode":"SKU_ID","keyName":"单品","valueCode":"01265CC82396E877687704ADF1C75589","valueName":"0.01元","createTime":1578064083000,"createUser":308071,"updateTime":1578064083000,"updateUser":308071,"remark":null,"productName":"公益捐款","typeCode":"GYJK","skuCode":"GYJK_ZH_0.01","sellingPrice":"0.01"}],"canBegin":false,"canJoin":false,"haveJoin":false,"isFollow":"0","isWhite":"1"}, // 支付信息
		payInfo: null, // 支付信息
		showOrderList: false,
		showAllRule: false, // 活动规则展示，默认收起
		rankList: null, // 排行榜
	}

	UNSAFE_componentWillMount() {
		0 && showPassWordLogin()
		if (getAuthorize('index')) {
			this.initMounted()
		}
	}

	async initMounted() {
		await this.getRankList()
		if (Config.cacheOperate) {
			let json = JSON.parse(Config.cacheOperate)
			if (history.location.pathname === json.page) {
				let methods = JSON.parse(json.methods)
				if (json.selectIdx > -1) {
					this.setState({
						selectIdx: json.selectIdx
					}, () => {
						if (this[methods.name]) {
							this[methods.name](methods.params)
							Config.cacheOperate = ''
						}
					})
				} else {
					if (this[methods.name]) {
						this[methods.name](methods.params)
						Config.cacheOperate = ''
					}
				}
			}
		}
	}

	// 选择奖品
	selectRewardIdx = (idx) => {
		this.setState({
			selectIdx: idx
		})
	}

	// 加载完图片才展示轮播
	loadSwiperImg = (e) => {
		let loopHeight = e.target.clientHeight * 0.75
		this.setState({
			loopHeight: loopHeight
		})
	}

	// 异常登录弹窗提示
	errLoginTip() {
		let loginTime = this.state.loginTime + 1
		this.setState({
			loginTime: loginTime
		}, () => {
			if (loginTime > 2 && isInBocApp()) {
				showTipsAlert('登录异常，请退出当前页面重新进入再试！', '我知道了')
			}
		})
	}

	// 点击1分钱按钮
	clickBtn = (e) => {
		e.preventDefault()
		let {selectIdx} = this.state
		if (selectIdx < 0) {
			showToast('请先选择一款锦盒再点打开吧')
			return
		}
		this.doLoginAndGetUser('buy')
	}

	// 获取中行用户信息
	async doLoginAndGetUser(type) {
		const theType = type
		if (!isInBocApp()) { // 非中行环境下
			if (isNotLoggedIn()) {
				Config.cacheOperate = JSON.stringify({
					page: '/index',
					methods: JSON.stringify({
						name: 'doSomeThing',
						params: theType
					}),
					selectIdx: this.state.selectIdx
				})
				showLogin()
			} else {
				this.doSomeThing(theType)
			}
			return
		}
		if (this.state.cipherText) {
			this.togglePartakeModal(theType)
			return
		}
		const res = await returnBocUserInfo()
		console.log(res.cipherText);
		if (res.cipherText) {
			this.setState({
				cipherText: res.cipherText
			}, () => {
				this.togglePartakeModal(theType)
			})
		}
	}

	// 触发马上参与方法
	togglePartakeModal(type) {
		let {cipherText} = this.state
		if (!cipherText) {
			return
		}
		if (Config.loginInfo && Config.bocUserLogin) {
			this.doSomeThing(type)
			return;
		}
		bocLogin({
			thirdToken: cipherText
		}).then(res => {
			if (res.success) {
				Config.bocUserLogin = true
				let authToken = res.valueObject.authToken
				let phone = res.valueObject.userInfo.user.mobile
				let userId = res.valueObject.exjf.userId
				let userInfo = {}
				userInfo.userId = userId
				userInfo.token = authToken
				userInfo.phoneNum = phone
				const _name = `userInfo${Config.channelId}`
				setStorageCache(_name, userInfo, true)
				Config.loginInfo = userInfo
				this.doSomeThing(type)
			} else if (res.code === '400002' || res.code === '400003') {
				this.errLoginTip()
				showToast('登录异常，请稍后重试！')
			} else {
				this.errLoginTip()
				showToast('登录异常，请稍后重试！')
			}
		}).catch(() => {
			this.errLoginTip()
			showToast('服务器异常，请稍后重试！')
		})
	}

	doSomeThing = (type) => {
		if (type === 'buy') { // 直接拉起购买
			this.getProductList()
		} else if (type === 'order') { // 直接查看订单
			this.toggleOrder()
		}
	}

	// 判断白名单，拿到商品信息
	getProductList = async () => {
		let res = await getAllProductList()
		if (res.success) {
			let data = res.datas
			if ((getTimeString() < getTimeString(data.countBeginTime)) || (getTimeString() < getTimeString(data.dateBegin))) {
				showTipsAlert('活动还没有开始哦~', '我知道了')
				return
			}
			if ((getTimeString() > getTimeString(data.countEndTime)) || (getTimeString() > getTimeString(data.dateEnd))) {
				showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
				return
			}
			let taskList = data.taskList.filter(item => item.taskNo === Config.taskNo)
			if (taskList.length === 0) { // 接口无数据返回
				showTipsAlert('Oops~当前参与的人太多了，请稍后重试', '我知道了')
				return;
			}
			// 判断用户不可参与的同时看是否有奖可领
			if (taskList[0].taskResult !== '0') { // 0 可参与 1 不氪参与
				this.isUserRewardExist()
				return;
			}
			let actionList = taskList[0].actionList[0]
			// console.log(actionList);
			if (actionList.isWhite && actionList.isWhite === '1') { // 白名单
				this.setState({
					payInfo: actionList
				})
			} else if (isInBocApp()) { // 非白名单 && 在中行APP
				let res = await changeBocString({
					cipherText: this.state.cipherText
				})
				console.log(res);
				if (res.success) {
					Config.cipherTextNew = res.datas.cipherText
					this.setState({
						payInfo: actionList
					})
				} else if (res.errorCode === '431008') { // 解密失败
					showToast('Oops~当前参与的人太多了，请稍后重试')
				} else if (res.errorCode === '431009') { // 不符合广东非深圳限制
					// showTipsAlert('如您确为广东（不含深圳）手机银行用户，请您移步“中国银行”手机银行APP>定位广东（不含深圳）>进入“生活”频道>点击“广东专属服务”内的“拆锦盒 送祝福”参与活动。')
					showTipsAlert('Sorry~您不是本次活动的受邀客户哦~', '我知道了')
				}
			} else { // 不是白名单
				// showTipsAlert('Sorry~您不是本次活动的受邀客户哦~')
				showTipsAlert('如您确为广东（不含深圳）手机银行用户，请您移步中国银行手机银行APP>进入“生活”频道>定位广东（不含深圳）>点击“广东专属服务”内的“锦盒送福运”参与活动')
			}
		} else if (res.errorCode === '410015' || res.errorCode === '410003') { // 登录过期
			// showToast('用户登录信息异常，请稍后重试！')
			clearUserInfo()
			setTimeout(() => {
				this.doLoginAndGetUser('buy')
			}, 200)
		} else if (res.errorCode === '400037') { // 方案未开始
			showTipsAlert('活动还没有开始哦~', '我知道了')
		} else if (res.errorCode === '400038') { // 方案已过期
			showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
		} else if (res.errorCode === '434006') { // 查询中行接口失败,请稍后再试
			showTipsAlert('当前太多人排队啦，请稍后重试', '我知道了')
		} else { // res.errorCode === '500'
			showToast('服务器异常，请稍后重试！')
		}
	}

	// 判断用户是否存在奖品
	isUserRewardExist = () => {
		let arr = []
		getUserOrderList({
			state: '0,-1'
		}).then(res => {
			if (res.code === '200') {
				arr = res.arr
			}
			if (arr.length > 0) {
				// let userPayReward = arr.filter(item => item.state === '0')
				// let userShareReward = arr.filter(item => item.state === '-1')
				// console.log(userPayReward, userShareReward);
				// userSelectArrReceive(this, userPayReward, userShareReward)
				showToast('您有待领取的礼品，赶紧领取吧', 3000)
				this.toggleOrder()
				return
			} else {
				let events = {
					msg: `您已经参加过活动了，快把祝福锦盒分享给您的好友吧～分享还有额外红包哦~`,
					btnText: '分享',
					methods: {
						vm: this,
						name: 'linkShare',
						needClose: true
					}
				}
				showTipsAlert(events['msg'], events['btnText'], events['methods'])
			}
		})
	}

	linkReward = () => {
		historyOfPush('/reward')
	}

	linkShare = () => {
		if (isInBocApp()) {
			showZhShareModules()
			return
		}
		showShareModules()
	}

	// 关闭弹窗
	closePayAlert = () => {
		this.setState({
			payInfo: null
		})
	}

	// 显示订单
	toggleOrder = async (bol = null) => {
		if (isNotLoggedIn() || (isInBocApp() && !Config.bocUserLogin)) {
			this.doLoginAndGetUser('order')
			return
		}
		let res = await getAllProductList()
		if (res.success) {
			let data = res.datas
			if ((getTimeString() < getTimeString(data.countBeginTime)) || (getTimeString() < getTimeString(data.dateBegin))) {
				showTipsAlert('活动还没有开始哦~', '我知道了')
				return
			}
			if ((getTimeString() > getTimeString(data.countEndTime)) || (getTimeString() > getTimeString(data.dateEnd))) {
				showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
				return
			}
		} else if (res.errorCode === '410015' || res.errorCode === '410003') {
			clearUserInfo()
			showLogin()
			return false
		} else if (res.errorCode === '400037') { // 方案未开始
			showTipsAlert('活动还没有开始哦~', '我知道了')
			return false
		} else if (res.errorCode === '400038') { // 方案已过期
			showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
			return false
		} else if (res.errorCode === '434006') { // 查询中行接口失败,请稍后再试
			showTipsAlert('当前太多人排队啦，请稍后重试', '我知道了')
			return false
		} else { // res.errorCode === '500'
			showToast('服务器异常，请稍后重试！')
			return false
		}
		this.setState({
			showOrderList: bol !== null ? bol : !this.state.showOrderList
		})
	}

	// 展开、收起活动规则
	toggleRule = () => {
		this.setState({
			showAllRule: !this.state.showAllRule
		})
	}

	// 图片加载
	imgOnLoad = (e) => {
		let name = e.target.getAttribute('data-num')
		this.setState({
			[name]: true
		})
	}

	// 获取排行榜
	getRankList = async () => {
		let res = await getRankList()
		// let res = {"success":true,"errorCode":null,"errorMessage":null,"datas":[{"staffCode":"135****2427","staffName":"135****2427","createTime":"01.17 14:34","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"183****5908","staffName":"183****5908","createTime":"01.17 14:31","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"158****7514","staffName":"158****7514","createTime":"01.17 14:22","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"139****0803","staffName":"139****0803","createTime":"01.17 14:20","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"159****7333","staffName":"159****7333","createTime":"01.17 14:17","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"136****0959","staffName":"136****0959","createTime":"01.17 14:14","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"137****5606","staffName":"137****5606","createTime":"01.17 13:59","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"139****5076","staffName":"139****5076","createTime":"01.17 13:48","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"135****0779","staffName":"135****0779","createTime":"01.17 13:49","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"137****4423","staffName":"137****4423","createTime":"01.17 13:47","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"138****1158","staffName":"138****1158","createTime":"01.17 13:34","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"156****0630","staffName":"156****0630","createTime":"01.17 13:02","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"132****6934","staffName":"132****6934","createTime":"01.17 12:59","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"137****1861","staffName":"137****1861","createTime":"01.17 12:48","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"155****3120","staffName":"155****3120","createTime":"01.17 12:08","rcombiName":"188元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"},{"staffCode":"157****7783","staffName":"157****7783","createTime":"01.17 11:46","rcombiName":"168元微信红包","phone":null,"rdefType":"BOC_GD_INTEGRAL"}],"recordCount":9}
		let list = res.success ? res.datas : []
		if (list.length === 0) {
			list.push({
				phone: '',
				rcombiName: ''
			})
		}
		return new Promise(resolve => {
			this.setState({
				rankList: list
			}, () => {
				resolve()
			})
		})
	}

	render() {
		const IndexImg1 = require('../../asstes/img/Index/index-bg01.jpg')
		const IndexImg2 = require('../../asstes/img/Index/index-bg02.jpg')
		const IndexImg81 = require('../../asstes/img/Index/index-bg08-01.jpg')
		const IndexImg82 = require('../../asstes/img/Index/index-bg08-02.jpg')
		const IndexImg83 = require('../../asstes/img/Index/index-bg08-03.jpg')
		const rule1 = require('../../asstes/img/Index/rule-01.jpg')
		const rule2 = require('../../asstes/img/Index/rule-02.jpg')
		const ruleContent = require('../../asstes/img/Index/rule-bg.jpg')
		const ruleArrow = require('../../asstes/img/Index/rule-arrow.png')
		const giftBtn = require('../../asstes/img/Index/gift-btn.png')

		const {imgOne, imgTwo, loopHeight, selectIdx, payInfo, showOrderList, showAllRule, rankList} = this.state
		let ruleContentHtml = '' // 活动规则
		if (showAllRule) { // 展开
			ruleContentHtml = Config.template.rule_all
		} else {
			ruleContentHtml = Config.template.rule_fold
		}

		const ruleStyle = {
			background: `url(${ruleContent})`,
			backgroundRepeat: 'repeat-y',
			backgroundSize: '100% auto',
		}

		return <div className="index-container">
			<div className="relative">
				<img data-num={'imgOne'} onLoad={this.imgOnLoad} src={IndexImg1} alt="图片1"/>
				{
					imgOne ?
						<div className="absolute-date-text flex-center-center">
							{Config.template.date}
						</div> : null
				}
			</div>
			{
				!imgOne ? null :
					<>
						{/* 抽奖机器 */}
						<div style={{position: 'relative'}}>
							<img data-num={'imgTwo'} onLoad={this.imgOnLoad} className="relative-img-top" src={IndexImg2} alt="图片2"/>
							{
								!imgTwo ? null :
									<>
										<div className="gift-list">
											{/*<img src={giftTest} alt=""/>*/}
											<GiftListComponent selectIdx={selectIdx} selectRewardIdx={this.selectRewardIdx}/>
											{/* 点击按钮 */}
											<img src={giftBtn} alt="/" className="gift-btn" onClick={this.clickBtn}/>
										</div>
										{/* 红包轮播 */}
										<div className="banner-red-package">
											<BannerComponent/>
										</div>
									</>
							}
						</div>
						{
							!imgTwo ? null :
								<>
									{/* 中奖名单 */}
									<div className="reward-list-outside-container">
										<img src={IndexImg81} alt="图片8-1"/>
										<div style={{position: 'relative'}}>
											<img className="relative-img-top" id={'reward-pic'} src={IndexImg82} onLoad={this.loadSwiperImg}
											     alt="图片8-2"/>
											<div className="reward-list-container flex-center-center">
												{
													loopHeight && rankList ?
														<AdComponent arr={rankList} height={loopHeight}/> : null
												}
											</div>
										</div>
										<img className="relative-img-top" src={IndexImg83} alt="图片8-3"/>
									</div>
									{/* 活动规则 */}
									<div className="rule-list-outside-container">
										<img src={rule1} alt="图片9"/>
										<img src={ruleContent} alt=""/>
										<div className="rule-content" style={ruleStyle} dangerouslySetInnerHTML={{__html: ruleContentHtml}}>
										</div>
										<div style={{position: 'relative'}} onClick={this.toggleRule}>
											<img src={rule2} alt="图片9"/>
											{
												showAllRule ?
													<div className="change-btn flex-center-center">
														<p>收起</p>
														<img className="btn-arrow top-rotate" src={ruleArrow} alt=""/>
													</div> : <div className="change-btn flex-center-center">
														<p>更多详情</p>
														<img className="btn-arrow" src={ruleArrow} alt=""/>
													</div>
											}
										</div>
									</div>
								</>
						}
					</>
			}
			<FloatNavigation toggleOrder={this.toggleOrder}/>
			{
				payInfo ?
					(payInfo.actionObjectList.length === 1 ?
						<PayComponent payInfo={payInfo} closePayAlert={this.closePayAlert}/> :
						<SelectPayComponent payInfo={payInfo} closePayAlert={this.closePayAlert}/>)
					: null
			}
			{
				showOrderList ? <OrderComponent toggleOrder={this.toggleOrder}/> : null
			}
			{0 ? <ShareOtherComponent/> : null}
		</div>
	}
}

export default Index;
